import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { UrlParamsState } from './url-params.state';
import { selectConfig } from '../config/config.selector';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AuthenticationResponse } from './authentication-response.model';

/**
 * Service handles SSO with MCI.
 * - SFD_FL_LegacySso_TokenEndPoint_JR18 : https://docs.google.com/spreadsheets/d/1cbuoEzzuo5OndV2ar3vQjUGSBOdzl68XZidJdLwIgkY/edit#gid=1439827657
 * - diagram: https://drive.google.com/file/d/117_3EM794L74t_hNyBCC2GO0eGeRK4rZ/view
 * - Klientský portál na správu TPP APP - MEP šablóna aplikácie: https://docs.google.com/spreadsheets/d/1tsnFceTs4X02h0PZnA9r-58lCL_OX13R3L-N-r5tapM/edit#gid=0
 */
@Injectable()
export class AuthenticationService {

    private mepSsoUrl: string;
    private webApiClientId: string;
    private mepSsoRedirectUri: string;

    private params(channelId: string, languageId: string) {
        return new HttpParams()
            .append('channel_id', channelId)
            .append('language_id', languageId)
            // email from Josef Bures:
            // Zdá se, že jsme nedodrželi SFD, a vyžadujeme response_type na vstupu (SFD říká, že
            // tam máme default hodnotu token).
            // Stalo se při třetí iteraci, kdy se měnila signatura funkce. Za tuto chybu se omlouvám. V každém
            // případě tohle upravíme, ale prosím zatím použijte volání obohacené o response_type=token.
            .append('response_type', 'token')
            // Aplikace využívající OAuth protokol, potažmo tedy AccessToken, potřebuje redirect_uri k tomu, aby mohla
            // tento token získat. Tato URL se pak se pak spojí s AccessTokenem a je možné zjistit, na který endpoint
            // (eventulně) byl tento token doručen. Vy voláte API volání, které vrací data do POST response JSONu, ale
            // pro vytvoření se volá OAuth jádro. To vyžaduje mít specifikovanou tuto url. Protože může být použita
            // v jeden čas jen jedna URL, tak je nutné při vícenásobné konfiguraci dodat přesnou hodnotu té konkrétní url.
            .append('redirect_uri', this.mepSsoRedirectUri)
            .append('access_type', 'online')
            .append('target_client_id', this.webApiClientId);
    }

    private headers(ibHash: string): HttpHeaders {
        return new HttpHeaders()
            .append('X-MEP-IB-HASH', ibHash);
    }

    constructor(private http: HttpClient, private store: Store<UrlParamsState>) {
        this.store.select(selectConfig).subscribe(config => {
            if (config) {
                this.mepSsoUrl = config.mepSsoUrl;
                this.webApiClientId = config.webApiClientId;
                this.mepSsoRedirectUri = config.mepSsoRedirectUri;
            }
        });
    }

    /**
     * Function calls MEP to exchange IB-Hash to access_token.
     * @returns {Observable<AuthenticationResponse>}
     */
    public authenticate(channelId: string, languageId: string, ibHash: string): Observable<AuthenticationResponse> {
        return this.http.get<AuthenticationResponse>(this.mepSsoUrl, {
            params: this.params(channelId, languageId),
            headers : this.headers(ibHash)
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/authentication.service.ts